import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { api } from '../utils/api';
import { toast } from 'sonner';

const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use ref to prevent race conditions under StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      const hash = location.hash;
      const params = new URLSearchParams(hash.substring(1));
      const sessionId = params.get('session_id');

      if (!sessionId) {
        toast.error('Invalid authentication response');
        navigate('/login', { replace: true });
        return;
      }

      try {
        const response = await api.post('/auth/google-session', null, {
          headers: { 'X-Session-ID': sessionId }
        });

        const { user: userData, needs_role_selection, is_new_user } = response.data;
        
        // If new user needs to select role, redirect to role selection
        if (needs_role_selection) {
          navigate('/select-role', { replace: true });
          toast.success(`Welcome, ${userData.name}! Please select your role.`);
          return;
        }
        
        // Redirect based on role
        const dashboardPath = `/${userData.role}`;
        navigate(dashboardPath, { replace: true, state: { user: userData } });
        toast.success(is_new_user ? `Welcome, ${userData.name}!` : `Welcome back, ${userData.name}!`);
      } catch (error) {
        console.error('Auth error:', error);
        toast.error('Authentication failed');
        navigate('/login', { replace: true });
      }
    };

    processSession();
  }, [location, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-stone-100">
      <div className="text-center">
        <div className="w-16 h-16 border-4 border-orange-700 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
        <p className="text-stone-600">Completing authentication...</p>
      </div>
    </div>
  );
};

export default AuthCallback;